const INDEX_ITEMS = [
  { label: '韩漫', letter: '韩', count: '1.2万部', desc: '热门韩国漫画大全' },
  { label: '日漫', letter: '日', count: '1.8万部', desc: '经典日本漫画精选' },
  { label: '国漫', letter: '国', count: '8千部', desc: '国产漫画崛起之作' },
  { label: '热血', letter: '热', count: '5千部', desc: '燃爆肾上腺素的热血漫画' },
  { label: '恋爱', letter: '恋', count: '6千部', desc: '甜到心坎的恋爱漫画' },
  { label: '奇幻', letter: '奇', count: '4千部', desc: '异世界奇幻冒险漫画' },
  { label: '悬疑', letter: '悬', count: '3千部', desc: '烧脑解谜悬疑漫画' },
  { label: '搞笑', letter: '笑', count: '4千部', desc: '轻松一刻搞笑漫画' },
  { label: '完结', letter: '完', count: '1.5万部', desc: '已完结漫画一次看够' },
];

export default function IndexSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          漫画索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按分类快速浏览，精准找到你想看的漫画类型
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.label}
              href="#topics"
              onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
              className="bg-background-50 rounded-xl border border-background-200 p-5 text-center group cursor-pointer transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 font-bold font-heading text-lg group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                {item.letter}
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">{item.label}</h3>
              <p className="text-xs text-primary-500 font-medium mb-1 whitespace-nowrap">{item.count}</p>
              <p className="text-xs text-foreground-400">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}